import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { firestore } from '../../firebase/firebase';
import { ConfirmUser } from '../../models/ConfirmUser';
import { CloseContactUser } from '../../models/CloseContactUser';
import MaterialTable from 'material-table';

const CloseContact: React.FC = () => {
  const match = useRouteMatch<{ id: string }>('/confirm-case/:id');
  const redId = match?.params.id;
  const [loading, setLoading] = useState(true);
  const [confirmUser, setConfirmUser] = useState<ConfirmUser>();
  const [closeContactUsers, setCloseContactUsers] = useState<
    CloseContactUser[]
  >([]);
  const [title, setTitle] = useState<string>();

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchYellowUsers = (id: string) => {
      setLoading(true);
      firestore
        .collection('red')
        .doc(redId)
        .get()
        .then((docData) => {
          const redUser = new ConfirmUser(
            docData.id,
            docData.data()?.name,
            docData.data()?.email,
            docData.data()?.icNumber,
            docData.data()?.contactNumber,
            docData.data()?.address,
            docData.data()?.postcode,
            docData.data()?.state
          );
          setConfirmUser(redUser);
          setTitle(`Close Contacts By ${redUser.name}`);

          return redUser.id;
        })
        .then((id) => {
          return firestore.collection('red').doc(id).collection('yellow').get();
        })
        .then((docData) => {
          const closeContactUsers: CloseContactUser[] = [];
          docData.docs.forEach((doc) => {
            const yellowUser = new CloseContactUser(
              doc.data().name,
              doc.data().ic,
              doc.data().contactNumber,
              doc.data().stationName,
              doc.data().timestamp.toDate().toString()
            );
            closeContactUsers.push(yellowUser);
          });
          return closeContactUsers;
        })
        .then((yellowUsers) => {
          console.log(yellowUsers);

          setCloseContactUsers(yellowUsers);
        })
        .finally(() => setLoading(false));
    };

    fetchYellowUsers(redId!!);
  }, [dispatch]);

  const getPageSize = (): number => {
    if (closeContactUsers.length < 5) {
      return 5;
    } else if (closeContactUsers.length < 10) {
      return 10;
    } else if (closeContactUsers.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <>
      <MaterialTable
        isLoading={loading}
        key={closeContactUsers.length}
        options={{
          search: false,
          pageSize: getPageSize(),
          pageSizeOptions: [],
          actionsColumnIndex: -1,
          exportButton: true,
        }}
        columns={[
          { title: 'Name', field: 'name' },
          { title: 'IC No.', field: 'ic' },
          { title: 'Contact Number', field: 'contactNumber' },
          { title: 'Station', field: 'stationName' },
          { title: 'Email', field: 'timestamp' },
        ]}
        data={closeContactUsers}
        title={title}
      />
    </>
  );
};

export default CloseContact;
